import React,{useState} from 'react';
import './header.css';
import CTA from './CTA';
import ME from '../../assets/linkedinmetransparent.png';
import HeaderSocials from './HeaderSocials';

export default function Header() {
  const[activeNav,setActiveNav] = useState('#contact')
  return (
    <header>
      <div className='container header__container'>
        <h5>👋 Hello I'm</h5>
        <h1>Rigers Allaraj</h1>
        <h5 className='text-light'>Frontend Developer</h5>
        <CTA />
        <HeaderSocials />
        <div className='me'>
          <img src={ME}></img>
        </div>
        <a href="#contact" onClick={() => setActiveNav('#contact') } className={activeNav === '#' ? 'contact' : 'scroll__down'}>Scroll Down</a>
      </div>
    </header>
  );
}
